import React from 'react';
import * as styles from './SidebarSectionIcon.module.scss';
import { PremadeSections } from './SidebarSectionsProvider';
import SVGIcon from '../components/SVGIcon';
import { gql } from '../graphql/generated';
import type { DocumentType } from '../graphql/generated';
import allTopicsIcon from '../icons/non-prefilled/16x16/allTopics.svg';
import favoriteIcon from '../icons/non-prefilled/16x16/favorite.svg';
import mentionIcon from '../icons/non-prefilled/16x16/mention.svg';
import openIcon from '../icons/non-prefilled/16x16/open.svg';
import pinOutlineIcon from '../icons/non-prefilled/16x16/pinOutline.svg';
import privateIcon from '../icons/non-prefilled/16x16/private.svg';
import shortcutIcon from '../icons/non-prefilled/16x16/shortcut.svg';
import textIcon from '../icons/non-prefilled/16x16/text.svg';
import verifiedIcon from '../icons/non-prefilled/16x16/verified.svg';
import aiChipSparkIcon from '../icons/non-prefilled/sidebar/aiChipSpark.svg';
import androidIcon from '../icons/non-prefilled/sidebar/android.svg';
import angleBracketsIcon from '../icons/non-prefilled/sidebar/angleBrackets.svg';
import bookCloseIcon from '../icons/non-prefilled/sidebar/bookClose.svg';
import bookmarksIcon from '../icons/non-prefilled/sidebar/bookmarks.svg';
import cloudIcon from '../icons/non-prefilled/sidebar/cloud.svg';
import cogIcon from '../icons/non-prefilled/sidebar/cog.svg';
import colorBrushIcon from '../icons/non-prefilled/sidebar/colorBrush.svg';
import currencyDollarIcon from '../icons/non-prefilled/sidebar/currencyDollar.svg';
import flagIcon from '../icons/non-prefilled/sidebar/flag.svg';
import focusIcon from '../icons/non-prefilled/sidebar/focus.svg';
import folderBookmarkIcon from '../icons/non-prefilled/sidebar/folderBookmark.svg';
import graduationHatIcon from '../icons/non-prefilled/sidebar/graduationHat.svg';
import graphStatsIcon from '../icons/non-prefilled/sidebar/graphStats.svg';
import graphStatsCircleIcon from '../icons/non-prefilled/sidebar/graphStatsCircle.svg';
import headphonesIcon from '../icons/non-prefilled/sidebar/headphones.svg';
import labFlaskExperimentIcon from '../icons/non-prefilled/sidebar/labFlaskExperiment.svg';
import languageCodeIcon from '../icons/non-prefilled/sidebar/languageCode.svg';
import lightbulbIcon from '../icons/non-prefilled/sidebar/lightbulb.svg';
import markdownIcon from '../icons/non-prefilled/sidebar/markdown.svg';
import megaphoneIcon from '../icons/non-prefilled/sidebar/megaphone.svg';
import modulePuzzleIcon from '../icons/non-prefilled/sidebar/modulePuzzle.svg';
import quillIcon from '../icons/non-prefilled/sidebar/quill.svg';
import rulerIcon from '../icons/non-prefilled/sidebar/ruler.svg';
import scriptTextIcon from '../icons/non-prefilled/sidebar/scriptText.svg';
import setupIcon from '../icons/non-prefilled/sidebar/setup.svg';
import sparkleIcon from '../icons/non-prefilled/sidebar/sparkle.svg';
import stopwatchIcon from '../icons/non-prefilled/sidebar/stopwatch.svg';
import tagsIcon from '../icons/non-prefilled/sidebar/tags.svg';
import vectorsAnchorIcon from '../icons/non-prefilled/sidebar/vectorsAnchor.svg';
import workflowBranchIcon from '../icons/non-prefilled/sidebar/workflowBranch.svg';
import wrenchIcon from '../icons/non-prefilled/sidebar/wrench.svg';
import appIcon from '../icons/prefilled/16x16/app.svg';

export const DEFAULT_SIDEBAR_ICON = { name: 'favorite', icon: favoriteIcon };

export const SIDEBAR_ICONS = [
  DEFAULT_SIDEBAR_ICON,
  { name: 'flag', icon: flagIcon },
  { name: 'mention', icon: mentionIcon },
  { name: 'verified', icon: verifiedIcon },
  { name: 'focus', icon: focusIcon },
  { name: 'modulePuzzle', icon: modulePuzzleIcon },
  { name: 'pin', icon: pinOutlineIcon },
  { name: 'sparkle', icon: sparkleIcon },
  { name: 'text', icon: textIcon },
  { name: 'open', icon: openIcon },
  { name: 'private', icon: privateIcon },
  { name: 'languageCode', icon: languageCodeIcon },
  { name: 'shortcut', icon: shortcutIcon },
  { name: 'android', icon: androidIcon },
  { name: 'graphStatsCircle', icon: graphStatsCircleIcon },
  { name: 'wrench', icon: wrenchIcon },
  { name: 'workflowBranch', icon: workflowBranchIcon },
  { name: 'tags', icon: tagsIcon },
  { name: 'vectorsAnchor', icon: vectorsAnchorIcon },
  { name: 'bookClose', icon: bookCloseIcon },
  { name: 'ruler', icon: rulerIcon },
  { name: 'stopwatch', icon: stopwatchIcon },
  { name: 'angleBrackets', icon: angleBracketsIcon },
  { name: 'headphones', icon: headphonesIcon },
  { name: 'lightbulb', icon: lightbulbIcon },
  { name: 'megaphone', icon: megaphoneIcon },
  { name: 'colorBrush', icon: colorBrushIcon },
  { name: 'markdown', icon: markdownIcon },
  { name: 'folderBookmark', icon: folderBookmarkIcon },
  { name: 'quill', icon: quillIcon },
  { name: 'bookmarks', icon: bookmarksIcon },
  { name: 'graphStats', icon: graphStatsIcon },
  { name: 'cloud', icon: cloudIcon },
  { name: 'aiChipSpark', icon: aiChipSparkIcon },
  { name: 'currencyDollar', icon: currencyDollarIcon },
  { name: 'cog', icon: cogIcon },
  { name: 'setup', icon: setupIcon },
  { name: 'scriptText', icon: scriptTextIcon },
  { name: 'labFlaskExperiment', icon: labFlaskExperimentIcon },
  { name: 'graduationHat', icon: graduationHatIcon },
];
const SIDEBAR_ICONS_MAP = SIDEBAR_ICONS.reduce<Record<string, string>>(
  (acc, { name, icon }) => ({ ...acc, [name]: icon }),
  {},
);

const SIDEBAR_SECTION_ICON_FRAGMENT = gql(`
    fragment SidebarSectionIcon_section on Section {
      id
      icon
      color
    }
  `);

interface SidebarSectionIconContainerProps {
  children: React.ReactNode;
  color: string | null;
}

export const SidebarSectionIconContainer = ({
  children,
  color,
}: SidebarSectionIconContainerProps) => (
  <span
    className={styles.sectionIcon}
    style={color ? { color: `#${color}` } : undefined}
  >
    {children}
  </span>
);

interface SidebarSectionIconProps {
  section: DocumentType<typeof SIDEBAR_SECTION_ICON_FRAGMENT>;
}

const SidebarSectionIcon = ({ section }: SidebarSectionIconProps) => {
  if (section.id === PremadeSections.MY_TOPICS) {
    return <SVGIcon className={styles.myTopicsIcon}>{allTopicsIcon}</SVGIcon>;
  }

  if (section.id === PremadeSections.ALL_TOPICS) {
    return <SVGIcon className={styles.allTopicsIcon}>{allTopicsIcon}</SVGIcon>;
  }

  if (section.id === PremadeSections.INTEGRATIONS) {
    return <SVGIcon>{appIcon}</SVGIcon>;
  }

  return (
    <SidebarSectionIconContainer color={section.color ?? null}>
      <SVGIcon>
        {section.icon
          ? SIDEBAR_ICONS_MAP[section.icon]
          : DEFAULT_SIDEBAR_ICON.icon}
      </SVGIcon>
    </SidebarSectionIconContainer>
  );
};

export default SidebarSectionIcon;
